/** Capitalize the first letter of each word (e.g. name fields). */
export function capitalizeWords(value) {
  if (value == null || value === '') return value;
  return String(value).replace(/(^|[\s\-_/])(\p{L})/gu, (_, sep, char) => sep + char.toUpperCase());
}

export function shouldCapitalizeField(field = {}) {
  const type = field.type || 'text';
  if (['number', 'email', 'date', 'select', 'boolean', 'image'].includes(type)) return false;
  const name = String(field.name || '').toLowerCase();
  if (/(email|password|mobile|phone|cnic|rfid|sku|code|ntn|strn|url|path)$/i.test(name)) return false;
  if (/(email|password|mobile|phone|cnic|rfid|sku|code|ntn|strn)/i.test(name)) return false;
  return true;
}
